import { List } from "immutable";

import { SectionStat } from "../../../../../models/state/sectionStats";

export const getSectionId = (
  sectionStat: SectionStat | null | undefined
): string | null | undefined => {
  return sectionStat ? sectionStat.sectionId : null;
};

export const getTimesStudied = (
  sectionStat: SectionStat | null | undefined
): number => {
  return sectionStat ? sectionStat.sessionsCompleted : 0;
};

export const getAverageScore = (
  sectionStat: SectionStat | null | undefined
) => {
  return sectionStat ? sectionStat.averageScore : 0;
};

export const getBestScore = (sectionStat: SectionStat | null | undefined) => {
  return sectionStat ? sectionStat.bestScore : 0;
};

export const getLastScore = (sectionStat: SectionStat | null | undefined) => {
  return sectionStat ? sectionStat.lastScore : 0;
};

export const getProficiency = (sectionStat: SectionStat | null | undefined) => {
  return sectionStat ? sectionStat.proficiency : 0;
};

export const getTotalStudyTime = (
  sectionStat: SectionStat | null | undefined
): number => {
  return sectionStat ? sectionStat.totalStudyTime : 0;
};

export const getSessionModulesStudied = (
  sectionStat: SectionStat | null | undefined
): number => {
  return sectionStat ? sectionStat.sessionModulesStudied : 0;
};

export const getSpacing = (sectionStat: SectionStat | null | undefined) => {
  return sectionStat ? sectionStat.spacing : 0;
};

export const getLastStudied = (
  sectionStat: SectionStat | null | undefined
): string | null | undefined => {
  return sectionStat ? sectionStat.lastStudied : null;
};

export const getModuleIdsStudied = (
  sectionStat: SectionStat | null | undefined
): List<string> | null | undefined => {
  return sectionStat ? sectionStat.moduleIdsStudied : null;
};

export const getModuleIdsIncorrectLast = (
  sectionStat: SectionStat | null | undefined
): List<string> | null | undefined => {
  return sectionStat ? sectionStat.moduleIdsIncorrectLast : null;
};
